import { render, staticRenderFns } from "./CatalogBoxContent.vue?vue&type=template&id=4c1b96d3&scoped=true&"
import script from "./CatalogBoxContent.vue?vue&type=script&lang=js&"
export * from "./CatalogBoxContent.vue?vue&type=script&lang=js&"
import style0 from "./CatalogBoxContent.vue?vue&type=style&index=0&id=4c1b96d3&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c1b96d3",
  null
  
)

export default component.exports